export { default } from './ConfirmDeleteAttributeModal';
